import { useTranslation } from 'react-i18next';
import { faCarWrench } from '@fortawesome/pro-regular-svg-icons/faCarWrench';
import { Col, Row, theme, Typography } from 'antd';
import { PosCard } from 'pos-client/components/shared/Display/Card/PosCard.tsx';
import { PosPageContent } from 'pos-client/layouts/page/PosPageContent.tsx';

import LocationMatrixTable from './LocationMatrixTable.tsx';

export const LocationServiceMatrix = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  return (
    <PosPageContent>
      <PosCard
        headerProps={{
          title: t('locations.services'),
          icon: faCarWrench,
        }}
      >
        <Row gutter={token.marginLG}>
          <Col span={24}>
            <Typography.Text>
              {t('locations.serviceMatrixDescription')}
            </Typography.Text>
          </Col>

          <Col span={24}>
            <LocationMatrixTable />
          </Col>
        </Row>
      </PosCard>
    </PosPageContent>
  );
};
